<template>
  <div>
    <h2>Strategies <span v-if="loaded" class="results">({{ displayedStrategies.length }})</span></h2>
    <subject-filter
      :subjects="filterOptions"
      :resource="resourceType"
      :page="pageType"/>
    <br>
    <router-link
      v-if="loaded && strategies.length === 0"
      class="browse-link"
      :to="{name: 'BrowseStrategiesPage'}">Find some strategies</router-link>
    <div v-for="strategy in displayedStrategies" :key="strategy.uuid">
      <strategy-display-card :strategy="strategy.content_body" :created="strategy.created_at"/>
    </div>
  </div>
</template>

<script>
import StrategyDisplayCard from '@/components/favorites/StrategyDisplayCard'
import SubjectFilter from '@/components/favorites/SubjectFilter'
import { mapState } from 'vuex'
import { getStrategyTags } from '@/api/strategies'

export default {
  name: 'StrategyFavorites',
  components: {
    StrategyDisplayCard,
    SubjectFilter
  },
  props: {
    strategies: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      strategySubjects: [],
      resourceType: 'strategies',
      pageType: 'favorites'
    }
  },
  computed: {
    ...mapState('favorites', ['loaded', 'filters']),
    displayedStrategies() {
      return (
        this.filterStrategiesBySubject(this.strategies, this.filters.strategies).sort((g1, g2) => {
          if (g1.created_at < g2.created_at) {
            return 1
          }
          if (g1.created_at > g2.created_at) {
            return -1
          }
          return 0
        }) || []
      )
    },
    filterOptions() {
      var options = ['All Subjects']
      this.strategies &&
        this.strategies.forEach(strategy => {
          strategy.content_body.tags.forEach(tag => {
            if (options.indexOf(tag) === -1 && this.strategySubjects.indexOf(tag) >= 0) {
              options.push(tag)
            }
          })
        })
      return options
    }
  },
  methods: {
    filterStrategiesBySubject(strategies, subject) {
      if (subject === 'All Subjects') {
        return [].concat(strategies)
      }
      return strategies.filter(strategy => {
        return strategy.content_body.tags.indexOf(subject) > -1
      })
    }
  },
  created() {
    getStrategyTags().then(result => {
      this.strategySubjects = result.subjects
    })
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.results {
  color: @blue;
  font-weight: 300;
}
.results-label {
  font-size: 0.7em;
}
.browse-link {
  font-size: 28px;
}
</style>
